module.exports = {"TXTWCL_PokerStars_My_Account":{"id":"TXTWCL_PokerStars_My_Account","defaultMessage":"Mitt konto"}}